import { useState, useEffect } from "react"
import { safeGet, safeSet } from "../helpers/localStorage"

const DEFAULT_PREFIX = "spinwheel_"

const usePersistedState = (key, defaultValue, { prefix = DEFAULT_PREFIX } = {}) => {
  const storageKey = `${prefix}${key}`
  const [value, setValue] = useState(() => safeGet(storageKey, defaultValue))

  useEffect(() => {
    safeSet(storageKey, value)
  }, [storageKey, value])

  return [value, setValue]
}

export default usePersistedState
